// extracted by mini-css-extract-plugin
module.exports = {"reminderWrapper":"reminder_reminderWrapper_HCZsQ","reminderUl":"reminder_reminderUl_MIj5T"};